import React from 'react';
import {Link} from 'react-router-dom';
import {ShirtIcon} from '../icons';
import {appName, appVersion} from './content';
import {LandingCta} from './cta';
import {LEGAL_DOCUMENTS, legalPath} from '../../legal';

const FOOTER_LINKS = [
    {href: '#features', label: 'Возможности'},
    {href: '#how', label: 'Как работает'},
    {href: '#security', label: 'Безопасность'},
];

/**
 * Футер публичной страницы: навигация, правовые документы, вход и строка с версией.
 *
 * Документы вынесены в отдельный ряд, а не подмешаны к якорям разделов: это не
 * навигация по витрине, а обязательные ссылки, которые должны находиться сразу
 * (2026-08-26_legal-documents, N-1).
 */
const LandingFooter: React.FC<{cta: LandingCta}> = ({cta}) => (
    <footer className="border-t border-ink-100 dark:border-white/5 mt-16">
        <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-xl bg-brand-500 flex items-center justify-center">
                    <ShirtIcon className="w-4 h-4 text-ink-900"/>
                </span>
                <span className="font-semibold text-ink-900 dark:text-ink-50">{appName()}</span>
            </div>

            <nav aria-label="Навигация в подвале" className="flex flex-wrap gap-x-6 gap-y-2 sm:mx-auto">
                {FOOTER_LINKS.map(link => (
                    <a
                        key={link.href}
                        href={link.href}
                        className="text-sm text-ink-500 dark:text-ink-400 hover:text-ink-900 dark:hover:text-white transition-colors"
                    >
                        {link.label}
                    </a>
                ))}
                <Link
                    to={cta.footer.href}
                    className="text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline"
                >
                    {cta.footer.label}
                </Link>
            </nav>

            <p className="text-xs text-ink-400 dark:text-ink-500">
                ©{new Date().getFullYear()} Created by Forwolk ({appName()}{appVersion() && ` v. ${appVersion()}`})
            </p>
        </div>

        <div className="border-t border-ink-100 dark:border-white/5">
            <nav
                aria-label="Правовые документы"
                className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-4 flex flex-wrap gap-x-6 gap-y-2"
            >
                {LEGAL_DOCUMENTS.map(document => (
                    <Link
                        key={document.slug}
                        to={legalPath(document)}
                        className="text-xs text-ink-500 dark:text-ink-400 hover:text-ink-900 dark:hover:text-white transition-colors duration-ui ease-out"
                    >
                        {document.title}
                    </Link>
                ))}
            </nav>
        </div>
    </footer>
);

export default LandingFooter;
